const listData = [
  { item1: "Exchange", item2: "Monthly Fee", title: true },
  { item1: "UNOCOIN", item2: "₹1,900.00" },
  { item1: "Zebpay", item2: "₹250.00" },
  { item1: "Wazirx", item2: "₹250.00" },
  { item1: "CoinDcx", item2: "₹100.00" },
  { item1: "PocketBits", item2: "₹00.0" },
];

export default listData;
